import { AppointmentRecurrenceOverlappingStrategy } from '@dreryk/egabinet-appointment-frontend-api';

import { FormContextValues } from '@dreryk/react-common';
import { RadioGroup, RadioGroupItem } from '@dreryk/react-components';

import { appointmentsTranslationKeys } from '../../../../../translations';

const OVERLAPPING_STRATEGY_DEFAULT_VALUE: AppointmentRecurrenceOverlappingStrategy = 'SKIP_OVERLAPPING_DATES';
const OVERLAPPING_STRATEGY_FIELD_NAME = 'overlappingStrategy';
const OVERLAPPING_STRATEGY_RADIO_ITEMS: RadioGroupItem<AppointmentRecurrenceOverlappingStrategy>[] = [
   {
      id: 'SKIP_OVERLAPPING_DATES',
      label: appointmentsTranslationKeys.create.form.overlappingStrategy.skip,
   },
   {
      id: 'CREATE_ANYWAY',
      label: appointmentsTranslationKeys.create.form.overlappingStrategy.anyway,
   },
];

type OverlappingStrategyFieldProps = Pick<FormContextValues<OverlappingStrategyFormBeanPart>, 'register'>;
type OverlappingStrategyFormBeanPart = {
   [OVERLAPPING_STRATEGY_FIELD_NAME]?: AppointmentRecurrenceOverlappingStrategy;
};

export const OverlappingStrategyField = (props: OverlappingStrategyFieldProps): JSX.Element => {
   return (
      <RadioGroup<AppointmentRecurrenceOverlappingStrategy>
         label={appointmentsTranslationKeys.create.form.overlappingStrategy.label}
         testId={OVERLAPPING_STRATEGY_FIELD_NAME}
         items={OVERLAPPING_STRATEGY_RADIO_ITEMS}
         controller={props.register(OVERLAPPING_STRATEGY_FIELD_NAME)}
         defaultValue={OVERLAPPING_STRATEGY_DEFAULT_VALUE}
      />
   );
};
